import BulkSearchForm from 'components/SingleBulkSearchPanel/components/BulkSearchForm';
import React, { useEffect, useState } from 'react';
import { getBulkSearchFormFields } from './constant';
import { getDropdown, searchWeekWiseList } from './apis';
import styles from "../../../../components/SingleBulkSearchPanel/styles.module.scss";
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import WeekwiseCalculationList from './WeekwiseCalculationListing';
import ALoader from 'views/pages/manage/common/a-loader';
import { processRowList } from 'views/pages/manage/businessArea/component/FirstForm/constant';

const WeekWiseCalculation = ({userPermissions}) => {

    const [form, setForm] = useState({})
    const [dropdowns, setDropdowns] = useState();
    const [rowList, setRowList] = useState();
    const [loader, setLoader] = useState();
    const [globalFilter, setGlobalFilter] = useState({})
    const [currentPage, setCurrentPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [currPageSize, setCurrentPageSize] = useState(10)
    const [isSearched, setIsSearched] = useState(false);

    const formHandler = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }))
    }

    const searchHandler = async ({ pageSize = currPageSize, page = currentPage, filters=globalFilter }) => {

        try {
            setLoader(true)
            const res = await searchWeekWiseList({ pageSize, page, filters })
            if(res?.code==200){
                console.log('paginated',res)
            const list=processRowList(res?.data?.paginatedData,dropdowns)||[]
            setGlobalFilter(filters);
            setRowList(list.map((item,index)=>({...item,id:index}))?? [])
            setRowCount(res?.data?.totalRecords)
            setCurrentPage(page)
            setCurrentPageSize(pageSize)
            }
        }
        catch (err) { }
        finally {
            setLoader(false)
            setIsSearched(true);
        }
    }
    const isSearchBtnDisabled = () => !form?.term || !form?.career

    useEffect(() => {
        init()
    }, [])
    const init = async () => {
        try{
        setLoader(true)
        const res = await getDropdown()
         setDropdowns(res);
        // console.log('dropdown', res)
        // await searchHandler({})
        }catch(err){
            console.error(err);
        }
        finally{
        setLoader(false)
        }
    }

    const handleBackToSearch = () => {
        setIsSearched(false);
    };


    return (<>
        {loader && <ALoader position="fixed" />}
        {!isSearched && (<div className={`${styles['panel-container']}`}>

            <div className={`${styles['panel-heading']}`}>{'Search Week wise calculation logic'}</div>

            <BulkSearchForm
                formFields={getBulkSearchFormFields({ ...dropdowns })}
                searchBtnTxt="Search"
                form={form}
                formHandler={formHandler}
                searchHandler={searchHandler}
                isBulkSearch={true}
                isSearchBtnDisabled={isSearchBtnDisabled()}
            />

        </div>
        )}

        {isSearched && (
            <WeekwiseCalculationList
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                loader={loader}
                dropdowns={dropdowns}
                searchHandler={searchHandler}
                rowList={rowList}
                rowCount={rowCount}
                currentPage={currentPage}
                currPageSize={currPageSize}
                onBack={handleBackToSearch} 
                userPermissions={userPermissions}
            />
        )}
    </>

    )
}

export default WeekWiseCalculation